import { Field, ErrorMessage } from 'formik';

export const ValidatedNumberInput = ({
  name,
  label,
  maxInteger = 3,
  maxDecimal = 2,
  maxValue = 500,
  onChangeExtra,
  value,
  setFieldValue
}) => {
  const handleKeyDown = (e) => {
    const { value, selectionStart, selectionEnd } = e.target;

    // Teclas permitidas (navegação e controle)
    const allowedKeys = ['Backspace', 'Delete', 'Tab',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End'];

    if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) {
      return;
    }

    // Substitui vírgula por ponto
    if (e.key === ',') {
      e.preventDefault();
      // Só permite ponto se não houver um já e se houver número antes
      if (!value.includes('.') && selectionStart > 0) {
        const newValue = insertAtPosition(value, selectionStart, '.', selectionEnd);
        setFieldValue(name, newValue);
      }
      return;
    }

    // Validação de caracteres permitidos
    if (!/[0-9.]/.test(e.key)) {
      e.preventDefault();
      return;
    }

    // Prevenção de múltiplos pontos
    if (e.key === '.' && (value.includes('.') || selectionStart === 0)) {
      e.preventDefault();
      return;
    }

    // Simula o novo valor para validação
    const newValue = insertAtPosition(value, selectionStart, e.key, selectionEnd);
    const [integerPart, decimalPart] = newValue.split('.');

    // Validações rigorosas
    if (integerPart.length > maxInteger) {
      e.preventDefault();
      return;
    }

    if (decimalPart && decimalPart.length > maxDecimal) {
      e.preventDefault();
      return;
    }

    if (Number(newValue) > maxValue) {
      e.preventDefault();
      return;
    }
  };

  const handleChange = (e) => {
    let sanitizedValue = e.target.value
      .replace(/[^\d.,]/g, '')  // Remove caracteres não numéricos
      .replace(/,/g, '.')       // Substitui vírgulas por pontos
      .replace(/(\..*)\./g, '$1'); // Remove pontos extras

    // Garante que comece com número
    if (sanitizedValue.startsWith('.')) {
      sanitizedValue = '0' + sanitizedValue;
    }

    // Validação final
    if (sanitizedValue === '' || isValidNumber(sanitizedValue, maxInteger, maxDecimal, maxValue)) {
      setFieldValue(name, sanitizedValue);
      if (onChangeExtra) onChangeExtra(sanitizedValue);
    }
  };

  return (
    <div className="anthropometry-form-group">
      <label htmlFor={name}>{label}</label>
      <Field
        type="text"
        name={name}
        id={name}
        value={value}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        inputMode="decimal"
      />
      <ErrorMessage name={name} component="div" className="error-message" />
    </div>
  );
};

// Funções auxiliares
function insertAtPosition(original, pos, char, endPos = pos) {
  return original.substring(0, pos) + char + original.substring(endPos);
}

function isValidNumber(value, maxInteger, maxDecimal, maxValue) {
  if (value === '' || value === '.') return false;

  const num = Number(value);
  if (isNaN(num)) return false;

  const parts = value.split('.');
  if (parts[0].length > maxInteger) return false;
  if (parts[1] && parts[1].length > maxDecimal) return false;
  if (num > maxValue) return false;

  return true;
}